<template>
      <main loadingactive="[object Object]">
        <div class="row">
          <div class="col">
            <div style="margin-bottom: 15px;">Dashboard</div>
            <div id="carouselExampleControls" data-ride="carousel" class="carousel slide" style="margin-bottom: 1rem;">
              <div id="bannerAnnounce" class="carousel-inner">
                <div class="carousel-item"><img src="https://ambsuperapi.com/img/banner-1.jpg" alt="banner 1" class="d-block w-100"
                    style="border-radius: 0.375rem;"></div>
                <div class="carousel-item active"><img src="../assets/banner/1.png" alt="banner 2" class="d-block w-100"
                    style="border-radius: 0.375rem;"></div>
              </div><a href="#carouselExampleControls" role="button" data-slide="prev"
                class="carousel-control-prev"><span aria-hidden="true" class="carousel-control-prev-icon"></span><span
                  class="sr-only">Previous</span></a><a href="#carouselExampleControls" role="button" data-slide="next"
                class="carousel-control-next"><span aria-hidden="true" class="carousel-control-next-icon"></span><span
                  class="sr-only">Next</span></a>
            </div>
            <div class="card mb-4">
              <div class="card-header">Your Credit</div>
              <div class="card-body">
                <div class="row">
                  <div class="col-6"><span class="card-sub-value">Total Credit</span></div>
                  <div class="col-3"><span class="card-sub-value">{{ getUser.wallet.credit | formatNumber }}</span></div>
                </div>
              </div>
            </div>
            <div class="card mb-4">
              <div class="card-header">Balance info</div>
              <div>
                <div>
                  <div class="card-body" style="text-align: center;">No data</div>
                </div>
              </div>
            </div>
            <div class="card mb-4">
              <div class="card-header">Your Downline</div>
              <div>
                <div class="card-body">
                  <div class="row">
                    <!---->
                    <div class="col-3"><span class="card-sub-title">Agent</span></div>
                    <div class="col-3"><span class="card-sub-title">Member</span></div>
                  </div>
                  <div class="row">
                    <!---->
                    <div class="col-3"><span id="txtDownlineOperator" class="card-sub-value">0</span></div>
                    <div class="col-3"><span id="txtDownlineMembers" class="card-sub-value">0</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card mb-4">
              <div class="card-header">Your Products</div>
              <div style="height: 596px; overflow-x: hidden;">
                <div class="card-body">
                  <nav>
                    <div id="nav-tab" role="tablist" class="nav nav-tabs"><a id="nav-0-tab" data-toggle="tab"
                        href="#nav-0" role="tab" aria-controls="nav-0" aria-selected="true"
                        class="nav-item nav-link nav-pill active"><span>Games Slot</span></a><a id="nav-1-tab"
                        data-toggle="tab" href="#nav-1" role="tab" aria-controls="nav-1" aria-selected="true"
                        class="nav-item nav-link nav-pill"><span>Live Casino</span></a><a id="nav-2-tab"
                        data-toggle="tab" href="#nav-2" role="tab" aria-controls="nav-2" aria-selected="true"
                        class="nav-item nav-link nav-pill"><span>Game Card</span></a><a id="nav-3-tab" data-toggle="tab"
                        href="#nav-3" role="tab" aria-controls="nav-3" aria-selected="true"
                        class="nav-item nav-link nav-pill"><span>Poker</span></a></div>
                  </nav>
                  <div id="nav-tabContent" class="tab-content mt-3">
                    <div id="nav-0" role="tabpanel" aria-labelledby="nav-0-tab" class="tab-pane fade active show">
                      <div style="margin-left: 10px;">
                        <div class="row">
                          <div class="col-6"><span class="card-sub-value">Product Name</span></div>
                          <div class="col-4"><span class="card-sub-value">Received Percentage</span></div>
                        </div>
                        <div v-for="(item, i) in getUser.royaltySetting.products" v-bind:key="i" class="row">
                          <div class="col-6"><span class="card-sub-value">{{ item.productId }}</span></div>
                          <div class="col-4"><span class="card-sub-value">{{ parseFloat(item.rate.THB) }}% (THB)</span></div>
                        </div>
                      </div>
                    </div>
                    <div id="nav-1" role="tabpanel" aria-labelledby="nav-1-tab" class="tab-pane fade">
                    </div>
                    <div id="nav-2" role="tabpanel" aria-labelledby="nav-2-tab" class="tab-pane fade">
                    </div>
                    <div id="nav-3" role="tabpanel" aria-labelledby="nav-3-tab" class="tab-pane fade">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-4"></div>
          </div>
        </div>
      </main>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "Home",
  computed: {
    ...mapGetters(["getUser"]),
  },
};
</script>